import { render, staticRenderFns } from "./page-chargeback-view.vue?vue&type=template&id=bd5c4058&scoped=true&"
import script from "./page-chargeback-view.vue?vue&type=script&lang=js&"
export * from "./page-chargeback-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5c4058",
  null
  
)

export default component.exports